import { createGlobalStyle } from "styled-components";
import { lightTheme } from "./components/Themes";

// Reads the palette directly instead of via styled-components theme context,
// since this is rendered once at the app root, outside any <ThemeProvider>.
const GlobalStyle = createGlobalStyle`

*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  overflow-x: hidden;
  font-family: 'Karla', sans-serif;
  background: ${lightTheme.body};
  color: ${lightTheme.text};
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Press Start 2P', 'Karla', sans-serif;
  font-weight: 400;
  line-height: 1.4;
}

img, svg {
  image-rendering: pixelated;
  image-rendering: crisp-edges;
}

button {
  font-family: inherit;
}

::selection {
  background: ${lightTheme.blossom};
  color: #fff;
}

::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-track {
  background: ${lightTheme.body};
}
::-webkit-scrollbar-thumb {
  background: ${lightTheme.blossom};
  border: 3px solid ${lightTheme.body};
}
`

export default GlobalStyle;
